/* eslint-disable */

//  Ramda v0.28.0
//  https://github.com/ramda/ramda
//  (c) 2013-2022 Scott Sauyet, Michael Hurley, and David Chambers
//  Ramda may be freely distributed under the MIT license.

(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = global || self, factory(global.R = {}));
  }(this, (function (exports) { 'use strict';
  
    function _typeof(obj) {
      if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        _typeof = function (obj) {
          return typeof obj;
        };
      } else {
        _typeof = function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
      }
  
      return _typeof(obj);
    }
  
    function _isPlaceholder(a) {
      return a != null && _typeof(a) === 'object' && a['@@functional/placeholder'] === true;
    }
  
    /**
     * Optimized internal one-arity curry function.
     *
     * @private
     * @category Function
     * @param {Function} fn The function to curry.
     * @return {Function} The curried function.
     */
  
    function _curry1(fn) {
      return function f1(a) {
        if (arguments.length === 0 || _isPlaceholder(a)) {
          return f1;
        } else {
          return fn.apply(this, arguments);
        }
      };
    }
  
    /**
     * Optimized internal two-arity curry function.
     *
     * @private
     * @category Function
     * @param {Function} fn The function to curry.
     * @return {Function} The curried function.
     */
  
    function _curry2(fn) {
      return function f2(a, b) {
        switch (arguments.length) {
          case 0:
            return f2;
  
          case 1:
            return _isPlaceholder(a) ? f2 : _curry1(function (_b) {
              return fn(a, _b);
            });
  
          default:
            return _isPlaceholder(a) && _isPlaceholder(b) ? f2 : _isPlaceholder(a) ? _curry1(function (_a) {
              return fn(_a, b);
            }) : _isPlaceholder(b) ? _curry1(function (_b) {
              return fn(a, _b);
            }) : fn(a, b);
        }
      };
    }
  
    /**
     * Tests whether or not an object is an array.
     *
     * @private
     * @param {*} val The object to test.
     * @return {Boolean} `true` if `val` is an array, `false` otherwise.
     * @example
     *
     *      _isArray([]); //=> true
     *      _isArray(null); //=> false
     *      _isArray({}); //=> false
     */
    var _isArray = Array.isArray || function _isArray(val) {
      return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
    };
  
    function _isTransformer(obj) {
      return obj != null && typeof obj['@@transducer/step'] === 'function';
    }
  
    /**
     * Returns a function that dispatches with different strategies based on the
     * object in list position (last argument). If it is an array, executes [fn].
     * Otherwise, if it has a function with one of the given method names, it will
     * execute that function (functor case). Otherwise, if it is a transformer,
     * uses transducer created by [transducerCreator] to return a new transformer
     * (transducer case).
     * Otherwise, it will default to executing [fn].
     *
     * @private
     * @param {Array} methodNames properties to check for a custom implementation
     * @param {Function} transducerCreator transducer factory if object is transformer
     * @param {Function} fn default ramda implementation
     * @return {Function} A function that dispatches on object in list position
     */
  
    function _dispatchable(methodNames, transducerCreator, fn) {
      return function () {
        if (arguments.length === 0) {
          return fn();
        }
  
        var obj = arguments[arguments.length - 1];
  
        if (!_isArray(obj)) {
          var idx = 0;
  
          while (idx < methodNames.length) {
            if (typeof obj[methodNames[idx]] === 'function') {
              return obj[methodNames[idx]].apply(obj, Array.prototype.slice.call(arguments, 0, -1));
            }
  
            idx += 1;
          }
  
          if (_isTransformer(obj)) {
            var transducer = transducerCreator.apply(null, Array.prototype.slice.call(arguments, 0, -1));
            return transducer(obj);
          }
        }
  
        return fn.apply(this, arguments);
      };
    }
  
    function _isString(x) {
      return Object.prototype.toString.call(x) === '[object String]';
    }
  
    /**
     * Tests whether or not an object is similar to an array.
     *
     * @private
     * @category Type
     * @category List
     * @sig * -> Boolean
     * @param {*} x The object to test.
     * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
     * @example
     *
     *      _isArrayLike([]); //=> true
     *      _isArrayLike(true); //=> false
     *      _isArrayLike({}); //=> false
     *      _isArrayLike({length: 10}); //=> false
     *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
     *      _isArrayLike({nodeType: 1, length: 1}) // => false
     */
  
    var _isArrayLike = _curry1(function isArrayLike(x) {
      if (_isArray(x)) {
        return true;
      }
  
      if (!x) {
        return false;
      }
  
      if (_typeof(x) !== 'object') {
        return false;
      }
  
      if (_isString(x)) {
        return false;
      }
  
      if (x.length === 0) {
        return true;
      }
  
      if (x.length > 0) {
        return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
      }
  
      return false;
    });
  
    /**
     * `_makeFlat` is a helper function that returns a one-level or fully recursive
     * function based on the flag passed in.
     *
     * @private
     */
  
    function _makeFlat(recursive) {
      return function flatt(list) {
        var value, jlen, j;
        var result = [];
        var idx = 0;
        var ilen = list.length;
  
        while (idx < ilen) {
          if (_isArrayLike(list[idx])) {
            value = recursive ? flatt(list[idx]) : list[idx];
            j = 0;
            jlen = value.length;
  
            while (j < jlen) {
              result[result.length] = value[j];
              j += 1;
            }
          } else {
            result[result.length] = list[idx];
          }
  
          idx += 1;
        }
  
        return result;
      };
    }
  
    function _forceReduced(x) {
      return {
        '@@transducer/value': x,
        '@@transducer/reduced': true
      };
    }
  
    function _xArrayReduce(xf, acc, list) {
      var idx = 0;
      var len = list.length;
  
      while (idx < len) {
        acc = xf['@@transducer/step'](acc, list[idx]);
  
        if (acc && acc['@@transducer/reduced']) {
          acc = acc['@@transducer/value'];
          break;
        }
  
        idx += 1;
      }
  
      return xf['@@transducer/result'](acc);
    }
  
    var symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
    function _createReduce(arrayReduce, methodReduce, iterableReduce) {
      return function _reduce(xf, acc, list) {
        if (_isArrayLike(list)) {
          return arrayReduce(xf, acc, list);
        }
  
        if (list == null) {
          return acc;
        }
  
        if (typeof list['fantasy-land/reduce'] === 'function') {
          return methodReduce(xf, acc, list, 'fantasy-land/reduce');
        }
  
        if (list[symIterator] != null) {
          return iterableReduce(xf, acc, list[symIterator]());
        }
  
        if (typeof list.next === 'function') {
          return iterableReduce(xf, acc, list);
        }
  
        if (typeof list.reduce === 'function') {
          return methodReduce(xf, acc, list, 'reduce');
        }
  
        throw new TypeError('reduce: list must be array or iterable');
      };
    }
  
    function _arity(n, fn) {
      /* eslint-disable no-unused-vars */
      switch (n) {
        case 0:
          return function () {
            return fn.apply(this, arguments);
          };
  
        case 1:
          return function (a0) {
            return fn.apply(this, arguments);
          };
  
        case 2:
          return function (a0, a1) {
            return fn.apply(this, arguments);
          };
  
        case 3:
          return function (a0, a1, a2) {
            return fn.apply(this, arguments);
          };
  
        case 4:
          return function (a0, a1, a2, a3) {
            return fn.apply(this, arguments);
          };
  
        case 5:
          return function (a0, a1, a2, a3, a4) {
            return fn.apply(this, arguments);
          };
  
        case 6:
          return function (a0, a1, a2, a3, a4, a5) {
            return fn.apply(this, arguments);
          };
  
        case 7:
          return function (a0, a1, a2, a3, a4, a5, a6) {
            return fn.apply(this, arguments);
          };
  
        case 8:
          return function (a0, a1, a2, a3, a4, a5, a6, a7) {
            return fn.apply(this, arguments);
          };
  
        case 9:
          return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
            return fn.apply(this, arguments);
          };
  
        case 10:
          return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
            return fn.apply(this, arguments);
          };
  
        default:
          throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
      }
    }
  
    /**
     * Creates a function that is bound to a context.
     * Note: `R.bind` does not provide the additional argument-binding capabilities of
     * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
     *
     * @func
     * @memberOf R
     * @since v0.6.0
     * @category Function
     * @category Object
     * @sig (* -> *) -> {*} -> (* -> *)
     * @param {Function} fn The function to bind to context
     * @param {Object} thisObj The context to bind `fn` to
     * @return {Function} A function that will execute in the context of `thisObj`.
     * @see R.partial
     * @example
     *
     *      const log = R.bind(console.log, console);
     *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
     *      // logs {a: 2}
     * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
     */
  
    var bind = _curry2(function bind(fn, thisObj) {
      return _arity(fn.length, function () {
        return fn.apply(thisObj, arguments);
      });
    });
  
    function _xIterableReduce(xf, acc, iter) {
      var step = iter.next();
  
      while (!step.done) {
        acc = xf['@@transducer/step'](acc, step.value);
  
        if (acc && acc['@@transducer/reduced']) {
          acc = acc['@@transducer/value'];
          break;
        }
  
        step = iter.next();
      }
  
      return xf['@@transducer/result'](acc);
    }
  
    function _xMethodReduce(xf, acc, obj, methodName) {
      return xf['@@transducer/result'](obj[methodName](bind(xf['@@transducer/step'], xf), acc));
    }
  
    var _xReduce = _createReduce(_xArrayReduce, _xMethodReduce, _xIterableReduce);
  
    var _xfBase = {
      init: function init() {
        return this.xf['@@transducer/init']();
      },
      result: function result(_result) {
        return this.xf['@@transducer/result'](_result);
      }
    };
  
    var tInit = '@@transducer/init';
    var tStep = '@@transducer/step';
    var tResult = '@@transducer/result';
  
    function XPreservingReduced(xf) {
      this.xf = xf;
    }
  
    XPreservingReduced.prototype[tInit] = _xfBase.init;
    XPreservingReduced.prototype[tResult] = _xfBase.result;
  
    XPreservingReduced.prototype[tStep] = function (result, input) {
      var ret = this.xf[tStep](result, input);
      return ret['@@transducer/reduced'] ? _forceReduced(ret) : ret;
    };
  
    function XFlatCat(xf) {
      this.xf = new XPreservingReduced(xf);
    }
  
    XFlatCat.prototype[tInit] = _xfBase.init;
    XFlatCat.prototype[tResult] = _xfBase.result;
  
    XFlatCat.prototype[tStep] = function (result, input) {
      return !_isArrayLike(input) ? _xArrayReduce(this.xf, result, [input]) : _xReduce(this.xf, result, input);
    };
  
    var _flatCat = function _xcat(xf) {
      return new XFlatCat(xf);
    };
  
    function XMap(f, xf) {
      this.xf = xf;
      this.f = f;
    }
  
    XMap.prototype['@@transducer/init'] = _xfBase.init;
    XMap.prototype['@@transducer/result'] = _xfBase.result;
  
    XMap.prototype['@@transducer/step'] = function (result, input) {
      return this.xf['@@transducer/step'](result, this.f(input));
    };
  
    var _xmap = function _xmap(f) {
      return function (xf) {
        return new XMap(f, xf);
      };
    };
  
    function _xchain(f) {
      return function (xf) {
        return _xmap(f)(_flatCat(xf));
      };
    }
  
    function _arrayReduce(reducer, acc, list) {
      var index = 0;
      var length = list.length;
  
      while (index < length) {
        acc = reducer(acc, list[index]);
        index += 1;
      }
  
      return acc;
    }
  
    function _map(fn, functor) {
      var idx = 0;
      var len = functor.length;
      var result = Array(len);
  
      while (idx < len) {
        result[idx] = fn(functor[idx]);
        idx += 1;
      }
  
      return result;
    }
  
    /**
     * Internal curryN function.
     *
     * @private
     * @category Function
     * @param {Number} length The arity of the curried function.
     * @param {Array} received An array of arguments received thus far.
     * @param {Function} fn The function to curry.
     * @return {Function} The curried function.
     */
  
    function _curryN(length, received, fn) {
      return function () {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
  
        while (combinedIdx < received.length || argsIdx < arguments.length) {
          var result;
  
          if (combinedIdx < received.length && (!_isPlaceholder(received[combinedIdx]) || argsIdx >= arguments.length)) {
            result = received[combinedIdx];
          } else {
            result = arguments[argsIdx];
            argsIdx += 1;
          }
  
          combined[combinedIdx] = result;
  
          if (!_isPlaceholder(result)) {
            left -= 1;
          }
  
          combinedIdx += 1;
        }
  
        return left <= 0 ? fn.apply(this, combined) : _arity(left, _curryN(length, combined, fn));
      };
    }
  
    /**
     * Returns a curried equivalent of the provided function, with the specified
     * arity. The curried function has two unusual capabilities. First, its
     * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
     * following are equivalent:
     *
     *   - `g(1)(2)(3)`
     *   - `g(1)(2, 3)`
     *   - `g(1, 2)(3)`
     *   - `g(1, 2, 3)`
     *
     * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
     * "gaps", allowing partial application of any combination of arguments,
     * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
     * the following are equivalent:
     *
     *   - `g(1, 2, 3)`
     *   - `g(_, 2, 3)(1)`
     *   - `g(_, _, 3)(1)(2)`
     *   - `g(_, _, 3)(1, 2)`
     *   - `g(_, 2)(1)(3)`
     *   - `g(_, 2)(1, 3)`
     *   - `g(_, 2)(_, 3)(1)`
     *
     * @func
     * @memberOf R
     * @since v0.5.0
     * @category Function
     * @sig Number -> (* -> a) -> (* -> a)
     * @param {Number} length The arity for the returned function.
     * @param {Function} fn The function to curry.
     * @return {Function} A new, curried function.
     * @see R.curry
     * @example
     *
     *      const sumArgs = (...args) => R.sum(args);
     *
     *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
     *      const f = curriedAddFourNumbers(1, 2);
     *      const g = f(3);
     *      g(4); //=> 10
     */
  
    var curryN = _curry2(function curryN(length, fn) {
      if (length === 1) {
        return _curry1(fn);
      }
  
      return _arity(length, _curryN(length, [], fn));
    });
  
    function _has(prop, obj) {
      return Object.prototype.hasOwnProperty.call(obj, prop);
    }
  
    var toString = Object.prototype.toString;
  
    var _isArguments = function () {
      return toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
        return toString.call(x) === '[object Arguments]';
      } : function _isArguments(x) {
        return _has('callee', x);
      };
    }();
  
    var hasEnumBug = !{
      toString: null
    }.propertyIsEnumerable('toString');
    var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString']; // Safari bug
  
    var hasArgsEnumBug = function () {
  
      return arguments.propertyIsEnumerable('length');
    }();
  
    var contains = function contains(list, item) {
      var idx = 0;
  
      while (idx < list.length) {
        if (list[idx] === item) {
          return true;
        }
  
        idx += 1;
      }
  
      return false;
    };
    /**
     * Returns a list containing the names of all the enumerable own properties of
     * the supplied object.
     * Note that the order of the output array is not guaranteed to be consistent
     * across different JS platforms.
     *
     * @func
     * @memberOf R
     * @since v0.1.0
     * @category Object
     * @sig {k: v} -> [k]
     * @param {Object} obj The object to extract properties from
     * @return {Array} An array of the object's own properties.
     * @see R.keysIn, R.values, R.toPairs
     * @example
     *
     *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
     */
  
  
    var keys = typeof Object.keys === 'function' && !hasArgsEnumBug ? _curry1(function keys(obj) {
      return Object(obj) !== obj ? [] : Object.keys(obj);
    }) : _curry1(function keys(obj) {
      if (Object(obj) !== obj) {
        return [];
      }
  
      var prop, nIdx;
      var ks = [];
  
      var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
  
      for (prop in obj) {
        if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
          ks[ks.length] = prop;
        }
      }
  
      if (hasEnumBug) {
        nIdx = nonEnumerableProps.length - 1;
  
        while (nIdx >= 0) {
          prop = nonEnumerableProps[nIdx];
  
          if (_has(prop, obj) && !contains(ks, prop)) {
            ks[ks.length] = prop;
          }
  
          nIdx -= 1;
        }
      }
  
      return ks;
    });
  
    /**
     * Takes a function and
     * a [functor](https://github.com/fantasyland/fantasy-land#functor),
     * applies the function to each of the functor's values, and returns
     * a functor of the same shape.
     *
     * Ramda provides suitable `map` implementations for `Array` and `Object`,
     * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
     *
     * Dispatches to the `map` method of the second argument, if present.
     *
     * Acts as a transducer if a transformer is given in list position.
     *
     * Also treats functions as functors and will compose them together.
     *
     * @func
     * @memberOf R
     * @since v0.1.0
     * @category List
     * @sig Functor f => (a -> b) -> f a -> f b
     * @param {Function} fn The function to be called on every element of the input `list`.
     * @param {Array} list The list to be iterated over.
     * @return {Array} The new list.
     * @see R.transduce, R.addIndex, R.pluck, R.project
     * @example
     *
     *      const double = x => x * 2;
     *
     *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
     *
     *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
     * @symb R.map(f, [a, b]) = [f(a), f(b)]
     * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
     * @symb R.map(f, functor_o) = functor_o.map(f)
     */
  
    var map = _curry2(_dispatchable(['fantasy-land/map', 'map'], _xmap, function map(fn, functor) {
      switch (Object.prototype.toString.call(functor)) {
        case '[object Function]':
          return curryN(functor.length, function () {
            return fn.call(this, functor.apply(this, arguments));
          });
  
        case '[object Object]':
          return _arrayReduce(function (acc, key) {
            acc[key] = fn(functor[key]);
            return acc;
          }, {}, keys(functor));
  
        default:
          return _map(fn, functor);
      }
    }));
  
    /**
     * `chain` maps a function over a list and concatenates the results. `chain`
     * is also known as `flatMap` in some libraries.
     *
     * Dispatches to the `chain` method of the second argument, if present,
     * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
     *
     * If second argument is a function, `chain(f, g)(x)` is equivalent to `f(g(x), x)`.
     *
     * Acts as a transducer if a transformer is given in list position.
     *
     * @func
     * @memberOf R
     * @since v0.3.0
     * @category List
     * @sig Chain m => (a -> m b) -> m a -> m b
     * @param {Function} fn The function to map with
     * @param {Array} list The list to map over
     * @return {Array} The result of flat-mapping `list` with `fn`
     * @example
     *
     *      const duplicate = n => [n, n];
     *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
     *
     *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
     */
  
    var chain = _curry2(_dispatchable(['fantasy-land/chain', 'chain'], _xchain, function chain(fn, monad) {
      if (typeof monad === 'function') {
        return function (x) {
          return fn(monad(x))(x);
        };
      }
  
      return _makeFlat(false)(map(fn, monad));
    }));
  
    function _pipe(f, g) {
      return function () {
        return g.call(this, f.apply(this, arguments));
      };
    }
  
    /**
     * Optimized internal three-arity curry function.
     *
     * @private
     * @category Function
     * @param {Function} fn The function to curry.
     * @return {Function} The curried function.
     */
  
    function _curry3(fn) {
      return function f3(a, b, c) {
        switch (arguments.length) {
          case 0:
            return f3;
  
          case 1:
            return _isPlaceholder(a) ? f3 : _curry2(function (_b, _c) {
              return fn(a, _b, _c);
            });
  
          case 2:
            return _isPlaceholder(a) && _isPlaceholder(b) ? f3 : _isPlaceholder(a) ? _curry2(function (_a, _c) {
              return fn(_a, b, _c);
            }) : _isPlaceholder(b) ? _curry2(function (_b, _c) {
              return fn(a, _b, _c);
            }) : _curry1(function (_c) {
              return fn(a, b, _c);
            });
  
          default:
            return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3 : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function (_a, _b) {
              return fn(_a, _b, c);
            }) : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function (_a, _c) {
              return fn(_a, b, _c);
            }) : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function (_b, _c) {
              return fn(a, _b, _c);
            }) : _isPlaceholder(a) ? _curry1(function (_a) {
              return fn(_a, b, c);
            }) : _isPlaceholder(b) ? _curry1(function (_b) {
              return fn(a, _b, c);
            }) : _isPlaceholder(c) ? _curry1(function (_c) {
              return fn(a, b, _c);
            }) : fn(a, b, c);
        }
      };
    }
  
    function XWrap(fn) {
      this.f = fn;
    }
  
    XWrap.prototype['@@transducer/init'] = function () {
      throw new Error('init not implemented on XWrap');
    };
  
    XWrap.prototype['@@transducer/result'] = function (acc) {
      return acc;
    };
  
    XWrap.prototype['@@transducer/step'] = function (acc, x) {
      return this.f(acc, x);
    };
  
    function _xwrap(fn) {
      return new XWrap(fn);
    }
  
    /**
     * Returns a single item by iterating through the list, successively calling
     * the iterator function and passing it an accumulator value and the current
     * value from the array, and then passing the result to the next call.
     *
     * The iterator function receives two values: *(acc, value)*. It may use
     * [`R.reduced`](#reduced) to shortcut the iteration.
     *
     * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
     * is *(value, acc)*.
     *
     * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
     * arrays), unlike the native `Array.prototype.reduce` method. For more details
     * on this behavior, see:
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
     *
     * Be cautious of mutating and returning the accumulator. If you reuse it across
     * invocations, it will continue to accumulate onto the same value. The general
     * recommendation is to always return a new value. If you can't do so for
     * performance reasons, then be sure to reinitialize the accumulator on each
     * invocation.
     *
     * Dispatches to the `reduce` method of the third argument, if present. When
     * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
     * shortcuting, as this is not implemented by `reduce`.
     *
     * @func
     * @memberOf R
     * @since v0.1.0
     * @category List
     * @sig ((a, b) -> a) -> a -> [b] -> a
     * @param {Function} fn The iterator function. Receives two values, the accumulator and the
     *        current element from the array.
     * @param {*} acc The accumulator value.
     * @param {Array} list The list to iterate over.
     * @return {*} The final, accumulated value.
     * @see R.reduced, R.addIndex, R.reduceRight
     * @example
     *
     *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
     *      //          -               -10
     *      //         / \              / \
     *      //        -   4           -6   4
     *      //       / \              / \
     *      //      -   3   ==>     -3   3
     *      //     / \              / \
     *      //    -   2           -1   2
     *      //   / \              / \
     *      //  0   1            0   1
     *
     * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
     */
  
    var reduce = _curry3(function (xf, acc, list) {
      return _xReduce(typeof xf === 'function' ? _xwrap(xf) : xf, acc, list);
    });
  
    /**
     * This checks whether a function has a [methodname] function. If it isn't an
     * array it will execute that function otherwise it will default to the ramda
     * implementation.
     *
     * @private
     * @param {Function} fn ramda implementation
     * @param {String} methodname property to check for a custom implementation
     * @return {Object} Whatever the return value of the method is.
     */
  
    function _checkForMethod(methodname, fn) {
      return function () {
        var length = arguments.length;
  
        if (length === 0) {
          return fn();
        }
  
        var obj = arguments[length - 1];
        return _isArray(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
      };
    }
  
    /**
     * Returns the elements of the given list or string (or object with a `slice`
     * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
     *
     * Dispatches to the `slice` method of the third argument, if present.
     *
     * @func
     * @memberOf R
     * @since v0.1.4
     * @category List
     * @sig Number -> Number -> [a] -> [a]
     * @sig Number -> Number -> String -> String
     * @param {Number} fromIndex The start index (inclusive).
     * @param {Number} toIndex The end index (exclusive).
     * @param {*} list
     * @return {*}
     * @example
     *
     *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
     *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
     *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
     *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
     *      R.slice(0, 3, 'ramda');                     //=> 'ram'
     */
  
    var slice = _curry3(_checkForMethod('slice', function slice(fromIndex, toIndex, list) {
      return Array.prototype.slice.call(list, fromIndex, toIndex);
    }));
  
    /**
     * Returns all but the first element of the given list or string (or object
     * with a `tail` method).
     *
     * Dispatches to the `slice` method of the first argument, if present.
     *
     * @func
     * @memberOf R
     * @since v0.1.0
     * @category List
     * @sig [a] -> [a]
     * @sig String -> String
     * @param {*} list
     * @return {*}
     * @see R.head, R.init, R.last
     * @example
     *
     *      R.tail([1, 2, 3]);  //=> [2, 3]
     *      R.tail([1, 2]);     //=> [2]
     *      R.tail([1]);        //=> []
     *      R.tail([]);         //=> []
     *
     *      R.tail('abc');  //=> 'bc'
     *      R.tail('ab');   //=> 'b'
     *      R.tail('a');    //=> ''
     *      R.tail('');     //=> ''
     */
  
    var tail = _curry1(_checkForMethod('tail', slice(1, Infinity)));
  
    /**
     * Performs left-to-right function composition. The first argument may have
     * any arity; the remaining arguments must be unary.
     *
     * In some libraries this function is named `sequence`.
     *
     * **Note:** The result of pipe is not automatically curried.
     *
     * @func
     * @memberOf R
     * @since v0.1.0
     * @category Function
     * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
     * @param {...Function} functions
     * @return {Function}
     * @see R.compose
     * @example
     *
     *      const f = R.pipe(Math.pow, R.negate, R.inc);
     *
     *      f(3, 4); // -(3^4) + 1
     * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
     * @symb R.pipe(f, g, h)(a)(b) = h(g(f(a)))(b)
     */
  
    function pipe() {
      if (arguments.length === 0) {
        throw new Error('pipe requires at least one argument');
      }
  
      return _arity(arguments[0].length, reduce(_pipe, arguments[0], tail(arguments)));
    }
  
    /**
     * Returns a new list or string with the elements or characters in reverse
     * order.
     *
     * @func
     * @memberOf R
     * @since v0.1.0
     * @category List
     * @sig [a] -> [a]
     * @sig String -> String
     * @param {Array|String} list
     * @return {Array|String}
     * @example
     *
     *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
     *      R.reverse([1, 2]);     //=> [2, 1]
     *      R.reverse([1]);        //=> [1]
     *      R.reverse([]);         //=> []
     *
     *      R.reverse('abc');      //=> 'cba'
     *      R.reverse('ab');       //=> 'ba'
     *      R.reverse('a');        //=> 'a'
     *      R.reverse('');         //=> ''
     */
  
    var reverse = _curry1(function reverse(list) {
      return _isString(list) ? list.split('').reverse().join('') : Array.prototype.slice.call(list, 0).reverse();
    });
  
    /**
     * Performs right-to-left function composition. The last argument may have
     * any arity; the remaining arguments must be unary.
     *
     * **Note:** The result of compose is not automatically curried.
     *
     * @func
     * @memberOf R
     * @since v0.1.0
     * @category Function
     * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
     * @param {...Function} ...functions The functions to compose
     * @return {Function}
     * @see R.pipe
     * @example
     *
     *      const classyGreeting = (firstName, lastName) => "The name's " + lastName + ", " + firstName + " " + lastName
     *      const yellGreeting = R.compose(R.toUpper, classyGreeting);
     *      yellGreeting('James', 'Bond'); //=> "THE NAME'S BOND, JAMES BOND"
     *
     *      R.compose(Math.abs, R.add(1), R.multiply(2))(-4) //=> 7
     *
     * @symb R.compose(f, g, h)(a, b) = f(g(h(a, b)))
     * @symb R.compose(f, g, h)(a)(b) = f(g(h(a)))(b)
     */
  
    function compose() {
      if (arguments.length === 0) {
        throw new Error('compose requires at least one argument');
      }
  
      return pipe.apply(this, reverse(arguments));
    }
  
    /**
     * Returns the nth element of the given list or string. If n is negative the
     * element at index length + n is returned.
     *
     * @func
     * @memberOf R
     * @since v0.1.0
     * @category List
     * @sig Number -> [a] -> a | Undefined
     * @sig Number -> String -> String
     * @param {Number} offset
     * @param {*} list
     * @return {*}
     * @example
     *
     *      const list = ['foo', 'bar', 'baz', 'quux'];
     *      R.nth(1, list); //=> 'bar'
     *      R.nth(-1, list); //=> 'quux'
     *      R.nth(-99, list); //=> undefined
     *
     *      R.nth(2, 'abc'); //=> 'c'
     *      R.nth(3, 'abc'); //=> ''
     * @symb R.nth(-1, [a, b, c]) = c
     * @symb R.nth(0, [a, b, c]) = a
     * @symb R.nth(1, [a, b, c]) = b
     */
  
    var nth = _curry2(function nth(offset, list) {
      var idx = offset < 0 ? list.length + offset : offset;
      return _isString(list) ? list.charAt(idx) : list[idx];
    });
  
    /**
     * Returns the first element of the given list or string. In some libraries
     * this function is named `first`.
     *
     * @func
     * @memberOf R
     * @since v0.1.0
     * @category List
     * @sig [a] -> a | Undefined
     * @sig String -> String
     * @param {Array|String} list
     * @return {*}
     * @see R.tail, R.init, R.last
     * @example
     *
     *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
     *      R.head([]); //=> undefined
     *
     *      R.head('abc'); //=> 'a'
     *      R.head(''); //=> ''
     */
  
    var head = nth(0);
  
    function _iterableReduce(reducer, acc, iter) {
      var step = iter.next();
  
      while (!step.done) {
        acc = reducer(acc, step.value);
        step = iter.next();
      }
  
      return acc;
    }
  
    function _methodReduce(reducer, acc, obj, methodName) {
      return obj[methodName](reducer, acc);
    }
  
    var _reduce = _createReduce(_arrayReduce, _methodReduce, _iterableReduce);
  
    function _identity(x) {
      return x;
    }
  
    /**
     * A function that does nothing but return the parameter supplied to it. Good
     * as a default or placeholder function.
     *
     * @func
     * @memberOf R
     * @since v0.1.0
     * @category Function
     * @sig a -> a
     * @param {*} x The value to return.
     * @return {*} The input value, `x`.
     * @example
     *
     *      R.identity(1); //=> 1
     *
     *      const obj = {};
     *      R.identity(obj) === obj; //=> true
     * @symb R.identity(a) = a
     */
  
    var identity = _curry1(_identity);
  
    /**
     * Performs left-to-right function composition using transforming function. The first function may have
     * any arity; the remaining functions must be unary.
     *
     * **Note:** The result of pipeWith is not automatically curried. Transforming function is not used on the
     * first argument.
     *
     * @func
     * @memberOf R
     * @since v0.26.0
     * @category Function
     * @sig ((* -> *), [((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)]) -> ((a, b, ..., n) -> z)
     * @param {Function} transformer The transforming function
     * @param {Array} functions The functions to pipe
     * @return {Function}
     * @see R.composeWith, R.pipe
     * @example
     *
     *      const pipeWhileNotNil = R.pipeWith((f, res) => R.isNil(res) ? res : f(res));
     *      const f = pipeWhileNotNil([Math.pow, R.negate, R.inc])
     *
     *      f(3, 4); // -(3^4) + 1
     * @symb R.pipeWith(f)([g, h, i])(...args) = f(i, f(h, g(...args)))
     */
  
    var pipeWith = _curry2(function pipeWith(xf, list) {
      if (list.length <= 0) {
        return identity;
      }
  
      var headList = head(list);
      var tailList = tail(list);
      return _arity(headList.length, function () {
        return _reduce(function (result, f) {
          return xf.call(this, f, result);
        }, headList.apply(this, arguments), tailList);
      });
    });
  
    /**
     * Performs right-to-left function composition using transforming function. The last function may have
     * any arity; the remaining functions must be unary. Unlike `compose`, functions are passed in an array.
     *
     * **Note:** The result of composeWith is not automatically curried. Transforming function is not used
     * on the last argument.
     *
     * @func
     * @memberOf R
     * @since v0.26.0
     * @category Function
     * @sig ((* -> *), [(y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)]) -> ((a, b, ..., n) -> z)
     * @param {Function} transformer The transforming function
     * @param {Array} functions The functions to compose
     * @return {Function}
     * @see R.compose, R.pipeWith
     * @example
     *
     *      const composeWhileNotNil = R.composeWith((f, res) => R.isNil(res) ? res : f(res));
     *
     *      composeWhileNotNil([R.inc, R.prop('age')])({age: 1}) //=> 2
     *      composeWhileNotNil([R.inc, R.prop('age')])({}) //=> undefined
     *
     * @symb R.composeWith(f)([g, h, i])(...args) = f(g, f(h, i(...args)))
     */
  
    var composeWith = _curry2(function composeWith(xf, list) {
      return pipeWith.apply(this, [xf, reverse(list)]);
    });
  
    function _arrayFromIterator(iter) {
      var list = [];
      var next;
  
      while (!(next = iter.next()).done) {
        list.push(next.value);
      }
  
      return list;
    }
  
    function _includesWith(pred, x, list) {
      var idx = 0;
      var len = list.length;
  
      while (idx < len) {
        if (pred(x, list[idx])) {
          return true;
        }
  
        idx += 1;
      }
  
      return false;
    }
  
    function _functionName(f) {
      // String(x => x) evaluates to "x => x", so the pattern may not match.
      var match = String(f).match(/^function (\w*)/);
      return match == null ? '' : match[1];
    }
  
    // Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    function _objectIs(a, b) {
      // SameValue algorithm
      if (a === b) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return a !== 0 || 1 / a === 1 / b;
      } else {
        // Step 6.a: NaN == NaN
        return a !== a && b !== b;
      }
    }
  
    var _objectIs$1 = typeof Object.is === 'function' ? Object.is : _objectIs;
  
    /**
     * Gives a single-word string description of the (native) type of a value,
     * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
     * attempt to distinguish user Object types any further, reporting them all as
     * 'Object'.
     *
     * @func
     * @memberOf R
     * @since v0.8.0
     * @category Type
     * @sig * -> String
     * @param {*} val The value to test
     * @return {String}
     * @example
     *
     *      R.type({}); //=> "Object"
     *      R.type(1); //=> "Number"
     *      R.type(false); //=> "Boolean"
     *      R.type('s'); //=> "String"
     *      R.type(null); //=> "Null"
     *      R.type([]); //=> "Array"
     *      R.type(/[A-z]/); //=> "RegExp"
     *      R.type(() => {}); //=> "Function"
     *      R.type(undefined); //=> "Undefined"
     */
  
    var type = _curry1(function type(val) {
      return val === null ? 'Null' : val === undefined ? 'Undefined' : Object.prototype.toString.call(val).slice(8, -1);
    });
  
    /**
     * private _uniqContentEquals function.
     * That function is checking equality of 2 iterator contents with 2 assumptions
     * - iterators lengths are the same
     * - iterators values are unique
     *
     * false-positive result will be returned for comparison of, e.g.
     * - [1,2,3] and [1,2,3,4]
     * - [1,1,1] and [1,2,3]
     * */
  
    function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
      var a = _arrayFromIterator(aIterator);
  
      var b = _arrayFromIterator(bIterator);
  
      function eq(_a, _b) {
        return _equals(_a, _b, stackA.slice(), stackB.slice());
      } // if *a* array contains any element that is not included in *b*
  
  
      return !_includesWith(function (b, aItem) {
        return !_includesWith(eq, aItem, b);
      }, b, a);
    }
  
    function _equals(a, b, stackA, stackB) {
      if (_objectIs$1(a, b)) {
        return true;
      }
  
      var typeA = type(a);
  
      if (typeA !== type(b)) {
        return false;
      }
  
      if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') {
        return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) && typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
      }
  
      if (typeof a.equals === 'function' || typeof b.equals === 'function') {
        return typeof a.equals === 'function' && a.equals(b) && typeof b.equals === 'function' && b.equals(a);
      }
  
      switch (typeA) {
        case 'Arguments':
        case 'Array':
        case 'Object':
          if (typeof a.constructor === 'function' && _functionName(a.constructor) === 'Promise') {
            return a === b;
          }
  
          break;
  
        case 'Boolean':
        case 'Number':
        case 'String':
          if (!(_typeof(a) === _typeof(b) && _objectIs$1(a.valueOf(), b.valueOf()))) {
            return false;
          }
  
          break;
  
        case 'Date':
          if (!_objectIs$1(a.valueOf(), b.valueOf())) {
            return false;
          }
  
          break;
  
        case 'Error':
          return a.name === b.name && a.message === b.message;
  
        case 'RegExp':
          if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) {
            return false;
          }
  
          break;
      }
  
      var idx = stackA.length - 1;
  
      while (idx >= 0) {
        if (stackA[idx] === a) {
          return stackB[idx] === b;
        }
  
        idx -= 1;
      }
  
      switch (typeA) {
        case 'Map':
          if (a.size !== b.size) {
            return false;
          }
  
          return _uniqContentEquals(a.entries(), b.entries(), stackA.concat([a]), stackB.concat([b]));
  
        case 'Set':
          if (a.size !== b.size) {
            return false;
          }
  
          return _uniqContentEquals(a.values(), b.values(), stackA.concat([a]), stackB.concat([b]));
  
        case 'Arguments':
        case 'Array':
        case 'Object':
        case 'Boolean':
        case 'Number':
        case 'String':
        case 'Date':
        case 'Error':
        case 'RegExp':
        case 'Int8Array':
        case 'Uint8Array':
        case 'Uint8ClampedArray':
        case 'Int16Array':
        case 'Uint16Array':
        case 'Int32Array':
        case 'Uint32Array':
        case 'Float32Array':
        case 'Float64Array':
        case 'ArrayBuffer':
          break;
  
        default:
          // Values of other types are only equal if identical.
          return false;
      }
  
      var keysA = keys(a);
  
      if (keysA.length !== keys(b).length) {
        return false;
      }
  
      var extendedStackA = stackA.concat([a]);
      var extendedStackB = stackB.concat([b]);
      idx = keysA.length - 1;
  
      while (idx >= 0) {
        var key = keysA[idx];
  
        if (!(_has(key, b) && _equals(b[key], a[key], extendedStackA, extendedStackB))) {
          return false;
        }
  
        idx -= 1;
      }
  
      return true;
    }
  
    /**
     * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
     * cyclical data structures.
     *
     * Dispatches symmetrically to the `equals` methods of both arguments, if
     * present.
     *
     * @func
     * @memberOf R
     * @since v0.15.0
     * @category Relation
     * @sig a -> b -> Boolean
     * @param {*} a
     * @param {*} b
     * @return {Boolean}
     * @example
     *
     *      R.equals(1, 1); //=> true
     *      R.equals(1, '1'); //=> false
     *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
     *
     *      const a = {}; a.v = a;
     *      const b = {}; b.v = b;
     *      R.equals(a, b); //=> true
     */
  
    var equals = _curry2(function equals(a, b) {
      return _equals(a, b, [], []);
    });
  
    /**
     * Creates a thunk out of a function. A thunk delays a calculation until
     * its result is needed, providing lazy evaluation of arguments.
     *
     * @func
     * @memberOf R
     * @since v0.26.0
     * @category Function
     * @sig ((a, b, ..., j) -> k) -> (a, b, ..., j) -> (() -> k)
     * @param {Function} fn A function to wrap in a thunk
     * @return {Function} Expects arguments for `fn` and returns a new function
     *  that, when called, applies those arguments to `fn`.
     * @see R.partial, R.partialRight
     * @example
     *
     *      R.thunkify(R.identity)(42)(); //=> 42
     *      R.thunkify((a, b) => a + b)(25, 17)(); //=> 42
     */
  
    var thunkify = _curry1(function thunkify(fn) {
      return curryN(fn.length, function createThunk() {
        var fnArgs = arguments;
        return function invokeThunk() {
          return fn.apply(this, fnArgs);
        };
      });
    });
  
    function _indexOf(list, a, idx) {
      var inf, item; // Array.prototype.indexOf doesn't exist below IE9
  
      if (typeof list.indexOf === 'function') {
        switch (_typeof(a)) {
          case 'number':
            if (a === 0) {
              // manually crawl the list to distinguish between +0 and -0
              inf = 1 / a;
  
              while (idx < list.length) {
                item = list[idx];
  
                if (item === 0 && 1 / item === inf) {
                  return idx;
                }
  
                idx += 1;
              }
  
              return -1;
            } else if (a !== a) {
              // NaN
              while (idx < list.length) {
                item = list[idx];
  
                if (typeof item === 'number' && item !== item) {
                  return idx;
                }
  
                idx += 1;
              }
  
              return -1;
            } // non-zero numbers can utilise Set
  
  
            return list.indexOf(a, idx);
          // all these types can utilise Set
  
          case 'string':
          case 'boolean':
          case 'function':
          case 'undefined':
            return list.indexOf(a, idx);
  
          case 'object':
            if (a === null) {
              // null can utilise Set
              return list.indexOf(a, idx);
            }
  
        }
      } // anything else not covered above, defer to R.equals
  
  
      while (idx < list.length) {
        if (equals(list[idx], a)) {
          return idx;
        }
  
        idx += 1;
      }
  
      return -1;
    }
  
    function _includes(a, list) {
      return _indexOf(list, a, 0) >= 0;
    }
  
    function _Set() {
      /* globals Set */
      this._nativeSet = typeof Set === 'function' ? new Set() : null;
      this._items = {};
    } // until we figure out why jsdoc chokes on this
    // @param item The item to add to the Set
    // @returns {boolean} true if the item did not exist prior, otherwise false
    //
  
  
    _Set.prototype.add = function (item) {
      return !hasOrAdd(item, true, this);
    }; //
    // @param item The item to check for existence in the Set
    // @returns {boolean} true if the item exists in the Set, otherwise false
    //
  
  
    _Set.prototype.has = function (item) {
      return hasOrAdd(item, false, this);
    }; //
    // Combines the logic for checking whether an item is a member of the set and
    // for adding a new item to the set.
    //
    // @param item       The item to check or add to the Set instance.
    // @param shouldAdd  If true, the item will be added to the set if it doesn't
    //                   already exist.
    // @param set        The set instance to check or add to.
    // @return {boolean} true if the item already existed, otherwise false.
    //
  
  
    function hasOrAdd(item, shouldAdd, set) {
      var type = _typeof(item);
  
      var prevSize, newSize;
  
      switch (type) {
        case 'string':
        case 'number':
          // distinguish between +0 and -0
          if (item === 0 && 1 / item === -Infinity) {
            if (set._items['-0']) {
              return true;
            } else {
              if (shouldAdd) {
                set._items['-0'] = true;
              }
  
              return false;
            }
          } // these types can all utilise the native Set
  
  
          if (set._nativeSet !== null) {
            if (shouldAdd) {
              prevSize = set._nativeSet.size;
  
              set._nativeSet.add(item);
  
              newSize = set._nativeSet.size;
              return newSize === prevSize;
            } else {
              return set._nativeSet.has(item);
            }
          } else {
            if (!(type in set._items)) {
              if (shouldAdd) {
                set._items[type] = {};
                set._items[type][item] = true;
              }
  
              return false;
            } else if (item in set._items[type]) {
              return true;
            } else {
              if (shouldAdd) {
                set._items[type][item] = true;
              }
  
              return false;
            }
          }
  
        case 'boolean':
          // set._items['boolean'] holds a two element array
          // representing [ falseExists, trueExists ]
          if (type in set._items) {
            var bIdx = item ? 1 : 0;
  
            if (set._items[type][bIdx]) {
              return true;
            } else {
              if (shouldAdd) {
                set._items[type][bIdx] = true;
              }
  
              return false;
            }
          } else {
            if (shouldAdd) {
              set._items[type] = item ? [false, true] : [true, false];
            }
  
            return false;
          }
  
        case 'function':
          // compare functions for reference equality
          if (set._nativeSet !== null) {
            if (shouldAdd) {
              prevSize = set._nativeSet.size;
  
              set._nativeSet.add(item);
  
              newSize = set._nativeSet.size;
              return newSize === prevSize;
            } else {
              return set._nativeSet.has(item);
            }
          } else {
            if (!(type in set._items)) {
              if (shouldAdd) {
                set._items[type] = [item];
              }
  
              return false;
            }
  
            if (!_includes(item, set._items[type])) {
              if (shouldAdd) {
                set._items[type].push(item);
              }
  
              return false;
            }
  
            return true;
          }
  
        case 'undefined':
          if (set._items[type]) {
            return true;
          } else {
            if (shouldAdd) {
              set._items[type] = true;
            }
  
            return false;
          }
  
        case 'object':
          if (item === null) {
            if (!set._items['null']) {
              if (shouldAdd) {
                set._items['null'] = true;
              }
  
              return false;
            }
  
            return true;
          }
  
        /* falls through */
  
        default:
          // reduce the search size of heterogeneous sets by creating buckets
          // for each type.
          type = Object.prototype.toString.call(item);
  
          if (!(type in set._items)) {
            if (shouldAdd) {
              set._items[type] = [item];
            }
  
            return false;
          } // scan through all previously applied items
  
  
          if (!_includes(item, set._items[type])) {
            if (shouldAdd) {
              set._items[type].push(item);
            }
  
            return false;
          }
  
          return true;
      }
    } // A simple Set type that honours R.equals semantics
  
    function XUniqBy(f, xf) {
      this.xf = xf;
      this.f = f;
      this.set = new _Set();
    }
  
    XUniqBy.prototype['@@transducer/init'] = _xfBase.init;
    XUniqBy.prototype['@@transducer/result'] = _xfBase.result;
  
    XUniqBy.prototype['@@transducer/step'] = function (result, input) {
      return this.set.add(this.f(input)) ? this.xf['@@transducer/step'](result, input) : result;
    };
  
    function _xuniqBy(f) {
      return function (xf) {
        return new XUniqBy(f, xf);
      };
    }
  
    /**
     * Returns a new list containing only one copy of each element in the original
     * list, based upon the value returned by applying the supplied function to
     * each list element. Prefers the first item if the supplied function produces
     * the same value on two items. [`R.equals`](#equals) is used for comparison.
     *
     * Acts as a transducer if a transformer is given in list position.
     *
     * @func
     * @memberOf R
     * @since v0.16.0
     * @category List
     * @sig (a -> b) -> [a] -> [a]
     * @param {Function} fn A function used to produce a value to use during comparisons.
     * @param {Array} list The array to consider.
     * @return {Array} The list of unique items.
     * @example
     *
     *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
     */
  
    var uniqBy = _curry2(_dispatchable([], _xuniqBy, function (fn, list) {
      var set = new _Set();
      var result = [];
      var idx = 0;
      var appliedItem, item;
  
      while (idx < list.length) {
        item = list[idx];
        appliedItem = fn(item);
  
        if (set.add(appliedItem)) {
          result.push(item);
        }
  
        idx += 1;
      }
  
      return result;
    }));
  
    /**
     * Returns a new list containing only one copy of each element in the original
     * list. [`R.equals`](#equals) is used to determine equality.
     *
     * @func
     * @memberOf R
     * @since v0.1.0
     * @category List
     * @sig [a] -> [a]
     * @param {Array} list The array to consider.
     * @return {Array} The list of unique items.
     * @example
     *
     *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
     *      R.uniq([1, '1']);     //=> [1, '1']
     *      R.uniq([[42], [42]]); //=> [[42]]
     */
  
    var uniq = uniqBy(identity);
  
    /**
     * Takes a spec object and a test object; returns true if the test satisfies
     * the spec. Each of the spec's own properties must be a predicate function.
     * Each predicate is applied to the value of the corresponding property of the
     * test object. `where` returns true if all the predicates return true, false
     * otherwise.
     *
     * `where` is well suited to declaratively expressing constraints for other
     * functions such as [`filter`](#filter) and [`find`](#find).
     *
     * @func
     * @memberOf R
     * @since v0.1.1
     * @category Object
     * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
     * @param {Object} spec
     * @param {Object} testObj
     * @return {Boolean}
     * @see R.propSatisfies, R.whereEq
     * @example
     *
     *      // pred :: Object -> Boolean
     *      const pred = R.where({
     *        a: R.equals('foo'),
     *        b: R.complement(R.equals('bar')),
     *        x: R.gt(R.__, 10),
     *        y: R.lt(R.__, 20)
     *      });
     *
     *      pred({a: 'foo', b: 'xxx', x: 11, y: 19}); //=> true
     *      pred({a: 'xxx', b: 'xxx', x: 11, y: 19}); //=> false
     *      pred({a: 'foo', b: 'bar', x: 11, y: 19}); //=> false
     *      pred({a: 'foo', b: 'xxx', x: 10, y: 19}); //=> false
     *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> false
     */
  
    var where = _curry2(function where(spec, testObj) {
      for (var prop in spec) {
        if (_has(prop, spec) && !spec[prop](testObj[prop])) {
          return false;
        }
      }
  
      return true;
    });
  
    /**
     * Takes a spec object and a test object; each of the spec's own properties must be a predicate function.
     * Each predicate is applied to the value of the corresponding property of the
     * test object. `whereAny` returns true if at least one of the predicates return true,
     * false otherwise.
     *
     * `whereAny` is well suited to declaratively expressing constraints for other
     * functions such as [`filter`](#filter) and [`find`](#find).
     *
     * @func
     * @memberOf R
     * @since v0.28.0
     * @category Object
     * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
     * @param {Object} spec
     * @param {Object} testObj
     * @return {Boolean}
     * @see R.propSatisfies, R.where
     * @example
     *
     *      // pred :: Object -> Boolean
     *      const pred = R.whereAny({
     *        a: R.equals('foo'),
     *        b: R.complement(R.equals('xxx')),
     *        x: R.gt(R.__, 10),
     *        y: R.lt(R.__, 20)
     *      });
     *
     *      pred({a: 'foo', b: 'xxx', x: 8, y: 34}); //=> true
     *      pred({a: 'xxx', b: 'xxx', x: 9, y: 21}); //=> false
     *      pred({a: 'bar', b: 'xxx', x: 10, y: 20}); //=> false
     *      pred({a: 'foo', b: 'bar', x: 10, y: 20}); //=> true
     *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> true
     */
  
    var whereAny = _curry2(function whereAny(spec, testObj) {
      for (var prop in spec) {
        if (_has(prop, spec) && spec[prop](testObj[prop])) {
          return true;
        }
      }
  
      return false;
    });
  
    exports.chain = chain;
    exports.compose = compose;
    exports.composeWith = composeWith;
    exports.equals = equals;
    exports.thunkify = thunkify;
    exports.uniq = uniq;
    exports.where = where;
    exports.whereAny = whereAny;
  
    Object.defineProperty(exports, '__esModule', { value: true });
  
  })));
  